/**
 * Web piloto: meta robots noindex cuando el build es env staging en Vercel.
 * Import from index.ts before App (same pattern as installWebChunkReloadGuard).
 */
import { Platform } from 'react-native';
import { isPilotDeployEnvironment } from './pilotDeployEnvironment';

if (Platform.OS === 'web' && typeof document !== 'undefined' && isPilotDeployEnvironment()) {
  let meta = document.querySelector('meta[name="robots"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'robots');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', 'noindex, nofollow');
}
